import { NotificationBar } from "@asosteam/asos-web-component-library-notification-bar";
import PropTypes from "prop-types";
import styles from "./styles";

const PremierFreeTrialError = ({ onClose, message }) => (
  <div className={styles.container}>
    <NotificationBar onClose={() => onClose()} type="error">
      <span>{message}</span>
    </NotificationBar>
  </div>
);

PremierFreeTrialError.propTypes = {
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

export default PremierFreeTrialError;
